import { PROCESS } from "@/lib/data";
import { useReveal } from "@/hooks/useReveal";

export const Process = () => {
  const ref = useReveal();
  return (
    <section id="tilgang" className="py-20 lg:py-24 relative">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <div ref={ref} className="reveal max-w-3xl mb-12">
          <span className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--accent))] font-semibold">
            Vores Tilgang
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mt-3 leading-[1.05]">
            Sådan skaber vi{" "}
            <span className="italic font-light text-white/60">resultater.</span>
          </h2>
          <p className="mt-5 text-white/60 max-w-2xl">
            En gennemprøvet proces med fuld gennemsigtighed og tæt dialog hele vejen.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS.map((p, i) => (
            <Step key={p.n} item={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

const Step = ({ item, index }) => {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`process-step-${index}`}
      className="reveal relative rounded-3xl border border-white/10 bg-[hsl(var(--bg-card))] p-7 hover:border-[hsl(var(--accent))]/50 transition-all duration-500"
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <div className="font-display text-5xl font-bold text-[hsl(var(--accent))]/80">{item.n}</div>
      <div className="mt-5 h-px w-full bg-white/10" />
      <h3 className="font-display text-xl font-semibold mt-5">{item.title}</h3>
      <p className="mt-3 text-sm text-white/60 leading-relaxed">{item.desc}</p>
    </div>
  );
};
